import HallFilterBlock from "./hall-filter-block";


export default HallFilterBlock;